import type { VariantSpecificationFormValue } from '@workspace/silk-ui';

export function validateVariantSpecifications(rows: VariantSpecificationFormValue[]): Record<string, string> {
  const errors: Record<string, string> = {};
  if (rows.length > 100) errors.specifications = 'Use at most 100 specifications.';
  const seen = new Set<string>();
  for (const row of rows) {
    for (const [field, limit] of [['group', 80], ['name', 120], ['value', 2000]] as const) {
      const value = row[field].trim();
      if ((field !== 'group' && !value) || [...value].length > limit || value.includes('\0')) {
        errors[`specification.${row.id}.${field}`] = `${field === 'group' ? 'Group is optional; use' : `Enter a ${field} with`} at most ${limit} characters and no NUL characters.`;
      }
    }
    const key = `${row.group.trim().toLowerCase()}\0${row.name.trim().toLowerCase()}`;
    if (seen.has(key)) errors[`specification.${row.id}.name`] = 'Use a unique name within this group.';
    seen.add(key);
  }
  return errors;
}

export function buildVariantSpecificationsPayload(rows: VariantSpecificationFormValue[]) {
  return rows.map(row => ({ group: row.group.trim(), name: row.name.trim(), value: row.value.trim() }));
}
